var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0008 7C12.4262 7 11.8751 6.78929 11.4687 6.41421C11.0624 6.03914 10.8341 5.53043 10.8341 5C10.8341 4.46957 11.0624 3.96086 11.4687 3.58579C11.8751 3.21071 12.4262 3 13.0008 3C13.5754 3 14.1265 3.21071 14.5329 3.58579C14.9392 3.96086 15.1675 4.46957 15.1675 5C15.1675 5.53043 14.9392 6.03914 14.5329 6.41421C14.1265 6.78929 13.5754 7 13.0008 7ZM13.0008 14C12.4262 14 11.8751 13.7893 11.4687 13.4142C11.0624 13.0391 10.8341 12.5304 10.8341 12C10.8341 11.4696 11.0624 10.9609 11.4687 10.5858C11.8751 10.2107 12.4262 10 13.0008 10C13.5754 10 14.1265 10.2107 14.5329 10.5858C14.9392 10.9609 15.1675 11.4696 15.1675 12C15.1675 12.5304 14.9392 13.0391 14.5329 13.4142C14.1265 13.7893 13.5754 14 13.0008 14ZM13.0008 21C12.4262 21 11.8751 20.7893 11.4687 20.4142C11.0624 20.0391 10.8341 19.5304 10.8341 19C10.8341 18.4696 11.0624 17.9609 11.4687 17.5858C11.8751 17.2107 12.4262 17 13.0008 17C13.5754 17 14.1265 17.2107 14.5329 17.5858C14.9392 17.9609 15.1675 18.4696 15.1675 19C15.1675 19.5304 14.9392 20.0391 14.5329 20.4142C14.1265 20.7893 13.5754 21 13.0008 21Z",
    fill: "#C6CCFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.862c8e16c67e7218e45636d2df603be8.svg";
export { ForwardRef as ReactComponent };